<template>
  <v-dialog
    v-model="dialog"
    persistent
    :overlay="false"
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{}">
      <div>
        <v-badge
          class="d-print-none"
          v-if="ItemCount"
          color="error "
          overlap
          :content="ItemCount.toLocaleString()"
        >
          <v-btn
            class="d-print-none"
            @click="OneClinckCart"
            @dblclick="OpenAddtoCart"
            icon
            color="primary"
          >
            <v-icon>fas fa-cart-plus</v-icon>
          </v-btn>
        </v-badge>

        <v-btn
          v-else-if="!ItemCount"
          @click="OneClinckCart"
          @dblclick="OpenAddtoCart"
          class="d-print-none"
          icon
          color="primary"
        >
          <v-icon>fas fa-cart-plus</v-icon>
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title class="grey lighten-3  ">
        <div class="col-10">
          {{ ItemObj.InvName }}
          <span>({{ parseInt(ItemObj.qty) }})</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon color="black" @click="closeCart">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-form v-model="valid" ref="Cartform">
          <BaseNumInput
            outlined
            :rules="[valideQty]"
            label="ITEM QTY"
            v-model.number="QTY"
          ></BaseNumInput>
          <BaseNumInput
            outlined
            label="ITEM PRICE"
            v-model.number="PRICE"
          ></BaseNumInput>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="OnAddToCart" :disabled="!valid" color="success"
          >Add To Cart</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    ItemObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      valid: true,
      QTY: 1,
      PRICE: 0,
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        // console.log(this.ItemCount, this.ItemPrice);
        this.$nextTick(() => {
          this.PRICE = this.ItemPrice;
          this.QTY = this.ItemCount || 1;
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getCarts"]),
    ItemCount() {
      const result = this.getCarts.find(item => {
        return (
          this.ItemObj.product == item.product && this.ItemObj.code == item.code
        );
      });
      // console.log(result);
      return result ? result.qty : 0;
    },
    ItemPrice() {
      const result = this.getCarts.find(item => {
        return (
          this.ItemObj.product == item.product && this.ItemObj.code == item.code
        );
      });
      //   console.log(qty);
      return result ? result.price : this.ItemObj.price;
    },
  },
  methods: {
    closeCart() {
      this.dialog = false;
    },
    OpenAddtoCart() {
      this.dialog = true;
    },
    OneClinckCart() {
      this.$store.dispatch("AddToCart", this.ItemObj);
    },
    valideQty(val) {
      // console.log(val);
      if (!val || isNaN(val.replace(/,/g, ""))) return "it is not a number";
      if (!isNaN(val)) this.QTY = parseInt(val.replace(/,/g, ""));
      if (val == 0) return `0 is not allowed`;
      if (val.replace(/,/g, "") <= this.ItemObj.qty) return true;

      return `you don't have ${val} Qty of ${this.ItemObj.InvName}`;
    },
    OnAddToCart() {
      if (this.$refs.Cartform.validate()) {
        // Native form submission is not yet supported
        // eslint-disable-next-line no-unused-vars
        let { AccountName, invCateg, ...item } = this.ItemObj;
        this.$store.commit("DIRECT_CART", {
          ...item,
          qty: this.QTY,
          price: this.PRICE,
        });
        this.closeCart();
      }
    },
  },
  mounted() {},
};
</script>
